import { render, staticRenderFns } from "./registration-approval-popup.vue?vue&type=template&id=e9b6d68e&"
import script from "./registration-approval-popup.ts?vue&type=script&lang=ts&"
export * from "./registration-approval-popup.ts?vue&type=script&lang=ts&"
import style0 from "./registration-approval-popup.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports